import $ from 'jquery';
import MembershipUtils from './../../shared/Membership';

export default () => {
    const $logInPopupContainer = $('#log-in-popup-wrap, #subnav-log-in');
    const $ctaElement = $logInPopupContainer.find('.subscribe');
    const $signInButton = $logInPopupContainer.find('.sign-in-1-wrap');
    const hideElementsMapping = {'EMAIL': $signInButton, 'PRINT': $signInButton};
    const stylesCtaElement = {'ANONYMOUS': 'anonymous-tiers', 'EMAIL': 'email-print-tiers', 'PRINT': 'email-print-tiers'};

    MembershipUtils.addCtaElementStyleClass($logInPopupContainer.find('.description-box'), stylesCtaElement);
    MembershipUtils.hideCtaElement(hideElementsMapping);
    MembershipUtils.changeCtaElementText($ctaElement);
}



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/MembershipPageUpdate/logInPopupCTAUpdate.js